module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26566",
      "conversations-internal-schema": "static-1.12810",
      "head-dlb": "static-1.4938",
      "hs-test-utils": "static-1.7973",
      "hubspot-url-utils": "static-1.4096",
      "HubStyleTokens": "static-2.11418",
      "I18n": "static-7.1612",
      "jasmine-runner": "static-1.6426",
      "quartz": "static-1.6963",
      "react": "static-7.185",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.486",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6096",
      "enviro": "static-4.428",
      "hs-promise-rejection-tracking": "static-1.5489",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "raven-hubspot": "static-1.6136",
      "bend-plugin-trellis-migration": "static-1.3367",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17952",
      "cv-backend-services": "static-1.1551",
      "hub-http": "static-1.6178",
      "immutable": "static-2.79",
      "immutable-less": "static-1.4606",
      "quartz-config": "static-1.741",
      "quartz-core": "static-1.6182",
      "transmute": "static-2.85",
      "HeadJS": "static-2.741",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7844",
      "framer-motion": "static-1.71",
      "hs-test-utils-bend-plugin": "static-1.3084",
      "msw": "static-1.39",
      "react-redux": "static-7.71",
      "redux": "static-4.16",
      "testing-library": "static-1.151",
      "foundations-theming": "static-1.4373",
      "i18n-data": "static-1.220",
      "metrics-js": "static-1.9600",
      "moment-timezone": "static-5.82",
      "react-utils": "static-2.5308",
      "jasmine": "static-4.4281",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.65",
      "styled-components": "static-2.89",
      "UIComponents": "static-3.8365",
      "visitor-ui-component-library-icons": "static-1.5907",
      "bender-build-tools": "static-1.3123",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4605",
      "apollo-stack-hubspot": "static-3.85",
      "classnames": "static-2.10",
      "cssUtils": "static-1.780",
      "customer-data-objects": "static-1.7620",
      "customer-data-ui-utilities": "static-1.9783",
      "data-fetching-client": "static-1.9631",
      "FileManagerCore": "static-1.38985",
      "FileManagerLib": "static-1.39126",
      "foundations-assets": "static-1.4813",
      "graphql": "static-1.81",
      "hs-promise-utils": "static-1.5550",
      "hubspot-apollo-client": "static-1.4833",
      "icons": "static-2.644",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.104",
      "react-virtualized": "static-2.98",
      "rpc-client-utils": "static-1.4607",
      "salesImages": "static-1.524",
      "timezone-utils": "static-2.5201",
      "ui-gdpr-components": "static-1.10304",
      "ts-schema": "static-1.4042",
      "hs-locale-management": "static-1.48",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.135",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.827",
      "hubspotter-http": "static-1.4616",
      "mobile-manifest-mixins": "static-1.515",
      "module-federation": "static-1.22",
      "quartz-auth": "static-1.638",
      "quartz-head": "static-1.628",
      "quartz-i18n": "static-1.638",
      "quartz-routing": "static-1.393",
      "quartz-test": "static-1.638",
      "quartz-tracking": "static-1.342",
      "quick-fetch": "static-1.3881",
      "react-rhumb": "static-1.16626",
      "ui-fonts": "static-1.680",
      "usage-tracker-container": "static-1.7286",
      "usage-tracker-core": "static-1.7146",
      "bend-plugin-foundations-components": "static-1.4113",
      "floating-ui": "static-1.55",
      "foundations-theming-specialty": "static-1.2089",
      "hs-story-utils": "static-1.9386",
      "react-create-root-preference": "static-1.11",
      "tanstack-table": "static-1.54",
      "trellis-assets": "static-1.1707",
      "ui-images": "static-2.1141",
      "bend-plugin-foundations-theming": "static-1.2856",
      "foundations-theming-base": "static-1.3358",
      "stylex": "static-1.32",
      "HubStyle": "static-2.11726",
      "sassPrefix": "static-1.155",
      "inbound-db-properties-service-client": "static-1.3805",
      "property-translator": "static-1.5358",
      "react-dnd-compat": "static-1.4577",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8812",
      "audio-components": "static-1.5845",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29213",
      "file-manager-components": "static-1.23486",
      "FileManagerImages": "static-1.36637",
      "foundations-components-legacy": "static-1.869",
      "immerable": "static-1.4110",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8920",
      "urlinator": "static-1.4488",
      "video-components": "static-1.13112",
      "video-data-lib": "static-1.34767",
      "video-embed": "static-1.35601",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.292",
      "bend-plugin-chirp-manifest": "static-1.17",
      "chirp-fetch": "static-1.1842",
      "hub-http-shared-msw-handlers": "static-1.9854",
      "hubspotter-http-shared-msw-handlers": "static-1.9852",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4982",
      "web-vitals": "static-1.4",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.21055",
      "ContentUtils": "static-1.68221",
      "copilot-toolkit": "static-1.10990",
      "customer-data-objects-ui-components": "static-1.12982",
      "sanitize": "static-1.4429",
      "sanitize-text": "static-1.8100",
      "content-assistance-lib": "static-1.7680",
      "usage-tracker": "static-1.7296",
      "ui-addon-iframeable": "static-1.9012",
      "video-components-external": "static-1.11109",
      "unified-auth-core-lib": "static-1.715",
      "content-icons-ui": "static-1.2214",
      "social-insights-client-types": "static-1.21953",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4144",
      "amplitude-session-replay-browser": "static-1.59",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4768",
      "integrations-lib": "static-1.15962",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5532",
      "magpie-types": "static-1.4992",
      "simple-logging-lib": "static-1.3006",
      "atom": "static-1.5029",
      "avatar-components": "static-1.2455",
      "reference-resolvers": "static-1.8127",
      "superstore": "static-1.4723",
      "ui-addon-video-player": "static-1.8655",
      "ui-coaching-tips": "static-1.28409",
      "navigation-messaging": "static-1.7198",
      "content-media-composition-data-lib": "static-1.12088",
      "content-media-compositions": "static-2.16095",
      "idb-keyval": "static-1.43",
      "media-bridge-lib": "static-1.18845",
      "fsm": "static-1.3689",
      "flux-actions": "static-1.331",
      "frontend-preferences-client": "static-1.7884",
      "integrations-error-boundary-lib": "static-1.13377",
      "integrations-tracking-lib": "static-1.5555",
      "laboratory-lib": "static-3.7115",
      "native-integrations-shared-strings": "static-1.7740",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10328",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11107",
      "ui-shepherd-react": "static-3.10105",
      "unified-auth": "static-1.434",
      "reactive-lib": "static-1.678",
      "growth-onboarding-feedback-components": "static-1.6540",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2969",
      "foundations-components-test-utils": "static-1.5327",
      "google-sheets-integration-lib": "static-1.93",
      "microsoft-drive-integration-lib": "static-1.207",
      "react-dlb": "static-1.78",
      "crm-record-cards-service-types": "static-1.3574",
      "framework-data-schema-resolvers": "static-1.6835",
      "location-customization-utils-lib": "static-1.9100",
      "batch-promise": "static-1.1507",
      "conditional-properties-service-client": "static-1.3761",
      "crm-pipelines-api-client-types": "static-1.4107",
      "framework-builder-read-service-client": "static-1.3974",
      "framework-data-schema-quick-fetch": "static-1.6740",
      "inbound-db-meta-service-client": "static-1.3555",
      "multi-currency-client-types": "static-1.3656",
      "persist-promise": "static-1.3664"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26566",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12810",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-test-utils": "/hs-test-utils/static-1.7973",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4096",
      "HubStyleTokens": "/HubStyleTokens/static-2.11418",
      "I18n": "/I18n/static-7.1612",
      "jasmine-runner": "/jasmine-runner/static-1.6426",
      "quartz": "/quartz/static-1.6963",
      "react": "/react/static-7.185",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.486",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6096",
      "enviro": "/enviro/static-4.428",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3367",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17952",
      "cv-backend-services": "/cv-backend-services/static-1.1551",
      "hub-http": "/hub-http/static-1.6178",
      "immutable": "/immutable/static-2.79",
      "immutable-less": "/immutable-less/static-1.4606",
      "quartz-config": "/quartz-config/static-1.741",
      "quartz-core": "/quartz-core/static-1.6182",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.741",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7844",
      "framer-motion": "/framer-motion/static-1.71",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3084",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.71",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.151",
      "foundations-theming": "/foundations-theming/static-1.4373",
      "i18n-data": "/i18n-data/static-1.220",
      "metrics-js": "/metrics-js/static-1.9600",
      "moment-timezone": "/moment-timezone/static-5.82",
      "react-utils": "/react-utils/static-2.5308",
      "jasmine": "/jasmine/static-4.4281",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.65",
      "styled-components": "/styled-components/static-2.89",
      "UIComponents": "/UIComponents/static-3.8365",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5907",
      "bender-build-tools": "/bender-build-tools/static-1.3123",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4605",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.780",
      "customer-data-objects": "/customer-data-objects/static-1.7620",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9783",
      "data-fetching-client": "/data-fetching-client/static-1.9631",
      "FileManagerCore": "/FileManagerCore/static-1.38985",
      "FileManagerLib": "/FileManagerLib/static-1.39126",
      "foundations-assets": "/foundations-assets/static-1.4813",
      "graphql": "/graphql/static-1.81",
      "hs-promise-utils": "/hs-promise-utils/static-1.5550",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4833",
      "icons": "/icons/static-2.644",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.104",
      "react-virtualized": "/react-virtualized/static-2.98",
      "rpc-client-utils": "/rpc-client-utils/static-1.4607",
      "salesImages": "/salesImages/static-1.524",
      "timezone-utils": "/timezone-utils/static-2.5201",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10304",
      "ts-schema": "/ts-schema/static-1.4042",
      "hs-locale-management": "/hs-locale-management/static-1.48",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.135",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.827",
      "hubspotter-http": "/hubspotter-http/static-1.4616",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
      "module-federation": "/module-federation/static-1.22",
      "quartz-auth": "/quartz-auth/static-1.638",
      "quartz-head": "/quartz-head/static-1.628",
      "quartz-i18n": "/quartz-i18n/static-1.638",
      "quartz-routing": "/quartz-routing/static-1.393",
      "quartz-test": "/quartz-test/static-1.638",
      "quartz-tracking": "/quartz-tracking/static-1.342",
      "quick-fetch": "/quick-fetch/static-1.3881",
      "react-rhumb": "/react-rhumb/static-1.16626",
      "ui-fonts": "/ui-fonts/static-1.680",
      "usage-tracker-container": "/usage-tracker-container/static-1.7286",
      "usage-tracker-core": "/usage-tracker-core/static-1.7146",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4113",
      "floating-ui": "/floating-ui/static-1.55",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2089",
      "hs-story-utils": "/hs-story-utils/static-1.9386",
      "react-create-root-preference": "/react-create-root-preference/static-1.11",
      "tanstack-table": "/tanstack-table/static-1.54",
      "trellis-assets": "/trellis-assets/static-1.1707",
      "ui-images": "/ui-images/static-2.1141",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2856",
      "foundations-theming-base": "/foundations-theming-base/static-1.3358",
      "stylex": "/stylex/static-1.32",
      "HubStyle": "/HubStyle/static-2.11726",
      "sassPrefix": "/sassPrefix/static-1.155",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3805",
      "property-translator": "/property-translator/static-1.5358",
      "react-dnd-compat": "/react-dnd-compat/static-1.4577",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8812",
      "audio-components": "/audio-components/static-1.5845",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29213",
      "file-manager-components": "/file-manager-components/static-1.23486",
      "FileManagerImages": "/FileManagerImages/static-1.36637",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.869",
      "immerable": "/immerable/static-1.4110",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8920",
      "urlinator": "/urlinator/static-1.4488",
      "video-components": "/video-components/static-1.13112",
      "video-data-lib": "/video-data-lib/static-1.34767",
      "video-embed": "/video-embed/static-1.35601",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.292",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.17",
      "chirp-fetch": "/chirp-fetch/static-1.1842",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9854",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9852",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4982",
      "web-vitals": "/web-vitals/static-1.4",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.21055",
      "ContentUtils": "/ContentUtils/static-1.68221",
      "copilot-toolkit": "/copilot-toolkit/static-1.10990",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12982",
      "sanitize": "/sanitize/static-1.4429",
      "sanitize-text": "/sanitize-text/static-1.8100",
      "content-assistance-lib": "/content-assistance-lib/static-1.7680",
      "usage-tracker": "/usage-tracker/static-1.7296",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9012",
      "video-components-external": "/video-components-external/static-1.11109",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.715",
      "content-icons-ui": "/content-icons-ui/static-1.2214",
      "social-insights-client-types": "/social-insights-client-types/static-1.21953",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4144",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4768",
      "integrations-lib": "/integrations-lib/static-1.15962",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5532",
      "magpie-types": "/magpie-types/static-1.4992",
      "simple-logging-lib": "/simple-logging-lib/static-1.3006",
      "atom": "/atom/static-1.5029",
      "avatar-components": "/avatar-components/static-1.2455",
      "reference-resolvers": "/reference-resolvers/static-1.8127",
      "superstore": "/superstore/static-1.4723",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8655",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28409",
      "navigation-messaging": "/navigation-messaging/static-1.7198",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12088",
      "content-media-compositions": "/content-media-compositions/static-2.16095",
      "idb-keyval": "/idb-keyval/static-1.43",
      "media-bridge-lib": "/media-bridge-lib/static-1.18845",
      "fsm": "/fsm/static-1.3689",
      "flux-actions": "/flux-actions/static-1.331",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7884",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13377",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5555",
      "laboratory-lib": "/laboratory-lib/static-3.7115",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7740",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10328",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11107",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10105",
      "unified-auth": "/unified-auth/static-1.434",
      "reactive-lib": "/reactive-lib/static-1.678",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6540",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2969",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5327",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.93",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.207",
      "react-dlb": "/react-dlb/static-1.78",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3574",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6835",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9100",
      "batch-promise": "/batch-promise/static-1.1507",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3761",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4107",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3974",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6740",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3555",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3656",
      "persist-promise": "/persist-promise/static-1.3664"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26566",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};